module.exports = __webpack_public_path__ + "static/img/logo-min.feee7797.png";